export const postPreviewSettings = (settings, additionalPayload = {}) => {
  const iframe = document.querySelector(".guide-preview-device iframe");
  if (!iframe?.contentWindow || !iframe.src) return false;

  try {
    const targetOrigin = new URL(iframe.src).origin;
    iframe.contentWindow.postMessage(
      { settings, ...additionalPayload },
      targetOrigin,
    );
    return true;
  } catch {
    return false;
  }
};

// A frame can reload after the draft was sent, or finish its API request after
// receiving it. Resend only once that exact preview has loaded its settings.
export const listenForPreviewReady = (sendSettings) => {
  const onMessage = (event) => {
    if (event.data?.type !== "guide-preview-ready") return;
    const iframe = document.querySelector(".guide-preview-device iframe");
    if (!iframe?.src || event.source !== iframe.contentWindow) return;
    try {
      if (event.origin !== new URL(iframe.src).origin) return;
    } catch {
      return;
    }
    sendSettings();
  };
  window.addEventListener("message", onMessage);
  return () => window.removeEventListener("message", onMessage);
};
